import { render } from "./TkEngagementWorkspace.vue?vue&type=template&id=3c824e59&scoped=true"
import script from "./TkEngagementWorkspace.vue?vue&type=script&lang=js"
export * from "./TkEngagementWorkspace.vue?vue&type=script&lang=js"

import "./TkEngagementWorkspace.vue?vue&type=style&index=0&id=3c824e59&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c824e59"]])

export default __exports__
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabs,QTab,QIcon,QBadge});
